import { defineStore } from 'pinia';
import profile from '@/network/profile';
import { useContractStore } from './contract';

export const usePaymentScheduleStore = defineStore('paymentSchedule', {
  state: () => {
    return {
      PaymentScheduleSummary: {},
      PaymentScheduleDetail: {},
      PaymentSchedule: [],
      InvoiceTerm: [],
      PaymentTerm: [],
      PaymentType: [],
      contractMedia: [],
      AdditionalProduction: 0,
      BusinessNature: 'Private',
      PaymentScheduleData: {},
      PaymentScheduleDataForSaving: {},
      PaymentTermSettings: [],
      InvoiceTermSettings: [],
      PaymentKeywords: [],
      CompanyEntityId: '',
    };
  },
  actions: {
    setPaymentScheduleSummary(value) {
      this.PaymentScheduleSummary = value;
    },
    getSummary() {
      return this.PaymentScheduleSummary;
    },

    setInvoiceTerm(value) {
      this.InvoiceTerm = value;
    },
    getInvoiceTerm() {
      return this.InvoiceTerm.sort((a, b) => a.Sort - b.Sort);
    },
    setPaymentTerm(value) {
      this.PaymentTerm = value;
    },
    getPaymentTerm() {
      return this.PaymentTerm.sort((a, b) => a.Sort - b.Sort);
    },
    setPaymentType(value) {
      this.PaymentType = value;
    },
    getPaymentType() {
      return this.PaymentType;
    },
    getContractMedia() {
      return this.contractMedia;
    },
    setContractMedia(value) {
      this.contractMedia = value;
    },
    getAdditionalProduction() {
      return this.AdditionalProduction;
    },
    setAdditionalProduction(value) {
      this.AdditionalProduction = value;
    },
    getBusinessNature() {
      return this.BusinessNature;
    },
    setBusinessNature(value) {
      this.BusinessNature = value;
    },
    getPaymentScheduleData() {
      return this.PaymentScheduleData;
    },
    getPaymentSchedule(payment_id) {
      if ((this.PaymentScheduleData?.length || 0) === 0) {
        return null;
      }
      return (
        this.PaymentScheduleData?.find((t) => t.UniqueId === payment_id) || null
      );
    },
    getSpecialPaymentTerm(payment_id) {
      const Payment = this.getPaymentSchedule(payment_id);

      var SpecialPaymentTerm = Payment?.SpecialPaymentTerm;
      if (SpecialPaymentTerm) {
        return JSON.parse(SpecialPaymentTerm);
      }
      return null;
    },
    setPaymentScheduleData(value) {
      this.PaymentScheduleData = value;
    },
    setDataPrepareForSave(value) {
      this.PaymentScheduleDataForSaving.company_entity_id =
        value.company_entity_id;
      if (value.paymentSummary) {
        this.PaymentScheduleDataForSaving.paymentSummary = value.paymentSummary;
      }
      if (value.paymentScheduleForm) {
        this.PaymentScheduleDataForSaving.paymentScheduleForm =
          value.paymentScheduleForm;
      }
      if (value.scheduleData) {
        this.PaymentScheduleDataForSaving.scheduleData = value.scheduleData;
      }
      if (value.userCode) {
        this.PaymentScheduleDataForSaving.userCode = value.userCode;
      }
      if (value.userName) {
        this.PaymentScheduleDataForSaving.userName = value.userName;
      }

      if (value.deletePaymentIds) {
        if (
          (this.PaymentScheduleDataForSaving?.deletePaymentIds || null) == null
        ) {
          this.PaymentScheduleDataForSaving.deletePaymentIds = [];
        }
        this.PaymentScheduleDataForSaving.deletePaymentIds.push(
          value.deletePaymentIds
        );
      }

      if (value.paymentSchedule) {
        var ScheduleData =
          this.PaymentScheduleDataForSaving?.paymentSchedule?.find(
            (t) => t.payment_id === value.paymentSchedule.payment_id
          ) || null;
        if (ScheduleData === null) {
          if (
            (this.PaymentScheduleDataForSaving?.paymentSchedule || null) == null
          ) {
            this.PaymentScheduleDataForSaving.paymentSchedule = [];
          }

          ScheduleData = value.paymentSchedule;

          this.PaymentScheduleDataForSaving.paymentSchedule.push(ScheduleData);
        } else {
          ScheduleData = value.paymentSchedule;
        }
      }

      var detailIndex = value.paymentScheduleDetail?.length || 0;

      for (let index = 0; index < detailIndex; index++) {
        const element = value.paymentScheduleDetail[index];
        var scheduleDetailData =
          this.PaymentScheduleDataForSaving?.paymentScheduleDetail?.find(
            (t) => t.paymentDetail_Id === element.paymentDetail_Id
          ) || null;
        if (scheduleDetailData === null) {
          if (
            (this.PaymentScheduleDataForSaving?.paymentScheduleDetail ||
              null) == null
          ) {
            this.PaymentScheduleDataForSaving.paymentScheduleDetail = [];
          }

          this.PaymentScheduleDataForSaving.paymentScheduleDetail.push(element);
        } else {
          var saveIndex =
            this.PaymentScheduleDataForSaving.paymentScheduleDetail.indexOf(
              scheduleDetailData
            );
          this.PaymentScheduleDataForSaving.paymentScheduleDetail[saveIndex] =
            element;
        }
      }

      this.PaymentScheduleDataForSaving.voidPaymentScheduleDetail =
        value.voidPaymentScheduleDetail;

      //this.PaymentScheduleDataForSaving = value;
    },
    clearDataPrepareForSave() {
      this.PaymentScheduleDataForSaving = {};
    },
    getsetDataPrepareForSave() {
      return this.PaymentScheduleDataForSaving;
    },
    getPaymentScheduleForSave() {
      return this.PaymentScheduleDataForSaving.paymentSchedule;
    },
    setPaymentScheduleForSave(value) {
      this.PaymentScheduleDataForSaving.paymentSchedule = value;
    },
    getPaymentScheduleDetailForSave() {
      return this.PaymentScheduleDataForSaving.paymentScheduleDetail;
    },
    setPaymentScheduleDetailForSave(value) {
      this.PaymentScheduleDataForSaving.paymentScheduleDetail = value;
    },
    getVoidPaymentScheduleDetailForSave() {
      return this.PaymentScheduleDataForSaving.voidPaymentScheduleDetail || [];
    },
    setVoidPaymentScheduleDetailForSave(value) {
      this.PaymentScheduleDataForSaving.paymentScheduleDetail = value;
    },
    setPaymentTermSettings(value) {
      this.PaymentTermSettings = value;
    },
    setInvoiceTermSettings(value) {
      this.InvoiceTermSettings = value;
    },
    setPaymentKeywords(value) {
      this.PaymentKeywords = value;
    },
    getPaymentKeywords() {
      return this.PaymentKeywords;
    },
    setCompanyEntityId(value) {
      this.CompanyEntityId = value;
    },
    getCompanyEntityId() {
      return this.CompanyEntityId;
    },
    async toSave() {
      const util = require('@/utilFunction');

      util.loading();
      await util
        .requestFromAWSWithData(
          util.dev_endpoint,
          'savePaymentSchedule',
          Object.assign(this.PaymentScheduleDataForSaving ?? {}, {
            contract_id: useContractStore().cId,
          })
        )
        .then((val) => {
          this.PaymentScheduleDataForSaving = {};
        });

      util.closeLoading();
      return '';
    },
    /**
* 检查付款计划的最小和最大日期是否与活动期间一致
* 此函数用于验证在多个付款计划中，最早的开始日期和最晚的结束日期是否与活动的开始和结束日期相同
* @returns {Promise<boolean>} 返回一个布尔值，表示日期是否匹配
*/
    MinMaxDatePaymentSchedule() {
      try {
        //修改media日期后,Internal Split/PaymentSchedule页面保存是否需要跟着修改
        if (!useContractStore().otherData.enableMinMaxMediaDate) {
          return true;
        }
        // 检查PaymentScheduleSummary和PaymentScheduleData是否存在
        if (!this.PaymentScheduleSummary || !this.PaymentScheduleData) {
          console.error('PaymentScheduleSummary or PaymentScheduleData is missing');
          return true;
        }

        // 如果PaymentScheduleData为空，直接返回true
        if (this.PaymentScheduleData.length === 0) {
          return true;
        }
        const util = require('@/utilFunction');

        // 获取活动的开始和结束日期
        const campaignStart = util.getDateFormat(this.PaymentScheduleSummary.campaignPeriodStart);
        const campaignEnd = util.getDateFormat(this.PaymentScheduleSummary.campaignPeriodEnd);
        console.log(22222222222222222, this.PaymentScheduleData)
        // 遍历所有付款计划，更新最小和最大日期
        for (let i = 0; i < this.PaymentScheduleData.length; i++) {
          const start = util.getDateFormat(this.PaymentScheduleData[i].CampaignPeriodStart);
          const end = util.getDateFormat(this.PaymentScheduleData[i].CampaignPeriodEnd);
          // 检查最小和最大日期是否与活动期间一致
          if (campaignStart !== start || campaignEnd !== end) {
            return false;
          }

        }


        return true;
      } catch (error) {
        console.error('Error in MinMaxDatePaymentSchedule:', error);
        return true;
      }
    },
  },
  persist: true,
});
